module.exports = __webpack_public_path__ + "static/media/lego1.06c56ac7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lego1.png
// module id = 288
// module chunks = 0